import { NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import { DASHBOARD_SLUGS } from 'portal/src/constants/luzmoDashboards';
import EvChargingView from 'portal/src/pages/evCharging/EvChargingView';
import isEvChargingViewEnabled from 'portal/src/pages/evCharging/isEvChargingViewEnabled';

import { RouteDefinition } from './routeGenerator';

export const evChargingRouteDefinitions: RouteDefinition[] = [
  {
    element: (
      <EvChargingView
        slug={DASHBOARD_SLUGS.EV_CHARGING.FACILITY}
        disabledSlug={DASHBOARD_SLUGS.EV_CHARGING.PREVIEW}
      />
    ),
    name: 'EV Facility Summary',
    path: NESTED_ROUTES.EV_CHARGING.FACILITY,
    description:
      'Compare facility-wide energy usage, costs, and EV charging impact',
  },
  {
    element: <EvChargingView slug={DASHBOARD_SLUGS.EV_CHARGING.STATION} />,
    name: 'EV Station Summary',
    path: NESTED_ROUTES.EV_CHARGING.STATION,
    shouldRenderLink: isEvChargingViewEnabled,
    description:
      'Track station performance, utilization rates, and time-of-use patterns',
  },
  {
    element: <EvChargingView slug={DASHBOARD_SLUGS.EV_CHARGING.SESSION} />,
    name: 'EV Session Summary',
    path: NESTED_ROUTES.EV_CHARGING.SESSION,
    shouldRenderLink: isEvChargingViewEnabled,
    description:
      'Explore individual charging sessions, user behavior, and metrics',
  },
];
